import { cn } from '@repo/ui/lib/utils'
import { Link } from '@tanstack/react-router'
import type React from 'react'
import type { BrandContent } from './shared'

export interface BrandProps {
  brand?: BrandContent
  className?: string
  showName?: boolean
}

export const Brand: React.FC<BrandProps> = ({ brand, className, showName = true }) => {
  if (!brand) return null

  return (
    <Link to="/" className={cn('flex items-center gap-2', className)}>
      {brand.logo && <div className="flex items-center">{brand.logo}</div>}
      {showName && <span className="text-lg font-semibold tracking-tight">{brand.name}</span>}
    </Link>
  )
}
